import React from 'react';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TranscriberResponseDto } from '@shared/services/apiService/apiService';
import { useTranscriberContext } from '../TranscriberContext';

export const TranscriberTable: React.FC<{
  transcribers: TranscriberResponseDto[];
}> = ({ transcribers }) => {
  const { setTranscriber, openDialog } = useTranscriberContext();
  const { t } = useTranslation();

  const handleEditTranscriber = (transcriber: TranscriberResponseDto) => {
    setTranscriber(transcriber);
    openDialog('createOpen');
  };

  const openDeleteDialog = (transcriber: TranscriberResponseDto) => {
    setTranscriber(transcriber);
    openDialog('deleteOpen');
  };

  return (
    <TableContainer component={Paper} className="">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className="">{t('transcriberPage.table.provider')}</TableCell>
            <TableCell className="">{t('transcriberPage.table.language')}</TableCell>
            <TableCell className="">{t('transcriberPage.table.actions')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transcribers.map((transcriber) => (
            <TableRow key={transcriber.id} className="">
              <TableCell className="">
                <Typography variant="body1" color="textPrimary">
                  {transcriber.provider}
                </Typography>
              </TableCell>
              <TableCell className="">
                <Typography variant="body1" color="textPrimary">
                  {transcriber.language}
                </Typography>
              </TableCell>
              <TableCell className="">
                <Button onClick={() => handleEditTranscriber(transcriber)} sx={{ mr: 1 }}>
                  {t('common.edit')}
                </Button>
                <Button color="error" onClick={() => openDeleteDialog(transcriber)}>
                  {t('common.delete')}
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
